module.exports = __webpack_public_path__ + "bg-02.1469022b1fff05936202.jpg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/img/bg-02.jpg
// module id = ../../../../../src/assets/img/bg-02.jpg
// module chunks = main